import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MaxBrainExperience } from 'app/library/experience/models/experience.model';

@Component({
    selector: 'app-grow-filter-by-experience-dialog',
    templateUrl: './grow-filter-by-experience-dialog.component.html',
    styleUrls: ['./grow-filter-by-experience-dialog.component.scss'],
})
export class GrowFilterByExperienceDialogComponent implements OnInit {
    @Input()
    experiences: MaxBrainExperience[] = [];

    @Input()
    selectedExperience: MaxBrainExperience;

    dataSource: MatTableDataSource<MaxBrainExperience>;
    displayedColumns = ['name', 'buttons'];

    list: MaxBrainExperience[] = [];
    initialList: MaxBrainExperience[] = [];

    constructor(public dialogRef: MatDialogRef<GrowFilterByExperienceDialogComponent>) {}

    ngOnInit() {
        this.list = [this.selectedExperience];
        this.initialList = this.list;

        this.dataSource = new MatTableDataSource(
            this.experiences.map((experience) => {
                experience = Object.assign(new MaxBrainExperience(), experience, {
                    selected: this.list.some((item) => item.id === experience.id),
                });

                return experience;
            })
        );
    }

    addToList(experience: MaxBrainExperience): void {
        this.list = [experience];
        this.dataSource = new MatTableDataSource(
            this.experiences.map((item) => {
                if (item.id === experience.id || this.list.find((item2) => item2.id === item.id)) {
                    item = Object.assign(new MaxBrainExperience(), item, {
                        selected: true,
                    });
                } else {
                    item = Object.assign(new MaxBrainExperience(), item, {
                        selected: false,
                    });
                }
                return item;
            })
        );
    }

    cancel(): void {
        this.list = this.initialList;

        this.dialogRef.close(false);
    }

    save(): void {
        this.dialogRef.close(this.list[0]);
    }
}
